export default "__VITE_ASSET__Rez$5t9l__"